export const ADMIN_TABLE_LIMIT = 10;
export const PRODUCT_LIST_LIMIT = 12;
export const ACCOUNT_LIST_LIMIT = 6;
